var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0zM5.306 9.177l4.452-4.452a.387.387 0 0 0 0-.547L9.21 3.63a.387.387 0 0 0-.547 0l-3.63 3.63-1.696-1.694a.387.387 0 0 0-.547 0l-.548.547a.387.387 0 0 0 0 .548L4.76 9.177a.387.387 0 0 0 .547 0z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.0e1e9984bf404bcf1a214d24483de13e.svg";
export { ForwardRef as ReactComponent };